import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FullMockEvaluate } from "@app/shared/models/mock-test-list";
import { environment } from "@environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class EvaluateQuestionService {
  private baseUrl = environment.apiUrl + "/api/v1/";

  constructor(private http: HttpClient) {}

  onManageWritingEvaluate(data, module) {
    let url = `${this.baseUrl}writing/${module.questionType}/${module.questionId}/writing-evaluate`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onPractiseWritingEvaluate(data, module) {
    let url = `${this.baseUrl}writing/${module.questionType}/${module.questionId}/writing-practise`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onManageReadingEvaluate(data, module) {
    let url = `${this.baseUrl}reading/${module.questionType}/${module.questionId}/reading-evaluate`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onPractiseReadingEvaluate(data, module) {
    let url = `${this.baseUrl}reading/${module.questionType}/${module.questionId}/reading-practise`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onManageSpeakingEvaluate(data, module) {
    let url = `${this.baseUrl}speaking/${module.questionType}/${module.questionId}/speaking-evaluate`;
    // var formData: any = new FormData();
    // for (var key in data) {
    //   const value = data[key];
    //   formData.append(key, value);
    // }
    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onManageDeepGram(data) {
    let url = `${this.baseUrl}deepgram`;
    var formData: any = new FormData();
    for (var key in data) {
      const value = data[key];
      formData.append(key, value);
    }
    return this.http.post<any>(url, formData).pipe(map((obj) => obj));
  }

  onPractiseSpeakingEvaluate(data, module) {
    console.log(data);
    let url = `${this.baseUrl}speaking/${module.questionType}/${module.questionId}/speaking-practise`;
    // var formData: any = new FormData();
    // for (var key in data) {
    //   const value = data[key];
    //   console.log(value)
    //   formData.append(key, value);
    // }
    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  ondefineGenderPitch(file) {
    let url = `${this.baseUrl}speaking/define-gender-pitch`;
    var formData: any = new FormData();
    formData.append("file", file);

    return this.http.post<any>(url, formData).pipe(map((obj) => obj));
  }

  onManageListeningEvaluate(data, module) {
    let url = `${this.baseUrl}listening/${module.questionType}/${module.questionId}/listening-evaluate`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onPractiseListeningEvaluate(data, module) {
    let url = `${this.baseUrl}listening/${module.questionType}/${module.questionId}/listening-practise`;

    return this.http.post<any>(url, data).pipe(map((obj) => obj));
  }

  onPredictionEvaluate(data, module, type) {
    let url = `${this.baseUrl}${module.moduleName.toLowerCase()}/${type}/${
      module.evaluateId
    }/evaluate-${type}`;
    if (module.moduleName.toLowerCase() != "speaking")
      return this.http.post<any>(url, data).pipe(map((obj) => obj));
    else {
      // var formData: any = new FormData();
      // formData.append("questions", JSON.stringify(data.userAnswers));
      // data.userAnswers.map((userAns: any) => {
      //   if (userAns.file) {
      //     formData.append('files', userAns.file)
      //   }
      // });
      // formData.append("questionId", data.questionId);
      // formData.append("questionType", data.questionType);

      return this.http.post<any>(url, data).pipe(map((obj) => obj));
    }
  }

  onEvaluateFullMock(data: FullMockEvaluate) {
    let url = this.baseUrl + `mock-test/${data.mockTestId}/evaluate-mock-test`;
    // var formData: any = new FormData();
    // formData.append("userAnswers", JSON.stringify(data.userAnswers));
    // data.userAnswers.map((userAns: any) => {
    //   if (userAns.file) {
    //     formData.append('files', userAns.file)
    //   }
    // });
    // formData.append("mockTestId", data.mockTestId);
    return this.http.post(url, data);
  }
}
